import React, { PropsWithChildren, ReactNode } from 'react'
import {
  Box as Body,
  Box,
  Box as Container,
  Box as Header,
  Box as RoundedBox,
  Text,
} from '@node-space/ui-components'
import { BackgroundGradient } from 'components/backgrounds/BackgroundGradient'
import { PoweredByBvnk } from 'components/logos/PoweredByBvnk'
import { FullScreenLayout } from './FullScreenLayout'

export interface PublicPageLayoutProps extends PropsWithChildren {
  header?: ReactNode
  footer?: ReactNode
}

export const PublicPageLayout = ({ header, children, footer }: PublicPageLayoutProps) => {
  return (
    <FullScreenLayout background="subtle" padding={24} className="md:p-10">
      <Container flexCol gap={12} align="center" width="full" className="max-w-[880px]">
        <PoweredByBvnk />
        <RoundedBox width="full" background="standard" className="rounded-2xl overflow-hidden">
          {header && (
            <Header paddingX={32} className="py-[72px] md:p-[60px] relative">
              <BackgroundGradient />
              <Box className="relative">{header}</Box>
            </Header>
          )}
          <Body flexCol gap={24} padding={32} className="md:px-[60px] md:pb-12 md:pt-10">
            {children}
          </Body>
        </RoundedBox>
        {footer && (
          <Text variant="caption-text" color="subdued" isCentered>
            {footer}
          </Text>
        )}
      </Container>
    </FullScreenLayout>
  )
}
